import { AnyAction } from 'redux';
import {
  GlobalActions,
  VhvV2XHoechsteEinzelwertePayload,
} from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../appState';
import { HoechsteEinzelwerte } from '../model/hoechsteEinzelwerte.model';

export const hoechsteEinzelwerteReducer = function (
  sectionState: HoechsteEinzelwerte = {},
  action: AnyAction,
  appState: IAppState,
): HoechsteEinzelwerte {
  if (action.type === GlobalActions.EINZELWERTE_CHANGED && appState.angebotsId === action.payload.angebotsId) {
    const castPayload = action.payload.einzelwerte as VhvV2XHoechsteEinzelwertePayload;
    sectionState = {
      ...sectionState,
      uhrHoechsterEinzelwert: castPayload.hoechsterEinzelwertUhr ?? sectionState.uhrHoechsterEinzelwert,
      kunstHoechsterEinzelwert: castPayload.hoechsterEinzelwertKunst ?? sectionState.kunstHoechsterEinzelwert,
      schmuckHoechsterEinzelwert: castPayload.hoechsterEinzelwertSchmuck ?? sectionState.schmuckHoechsterEinzelwert,
    };
  }
  return sectionState;
};
